import lang from '@/lang/csr';

export default ({ store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en, 'csr');
  const subtitle = store.$i18n.t('description');
  const title = store.$i18n.t('title');
  const description = store.$i18n.t('description');
  store.commit('jumbotron/SET_JUMBOTRON', { subtitle, title, type: 'expanded' });
  store.commit('pageContent/setHead', { title, description });
};
